// extracted by mini-css-extract-plugin
export default {"container":"SelectorPage_container__o4sIq","remove":"SelectorPage_remove__qKV15"};